<template>
    <v-col class="py-0 pt-2">
        <div class="d-flex">
            <v-icon
                color="black"
                class="mr-2"
            >
                mdi-pound
            </v-icon>
            <p class="subtitle-2 mt-1 mb-0">
                {{ label }}
            </p>
        </div>
        <div class="d-flex justify-space-between">
            <p class="subtitle-1 mb-0 font-weight-bold">
                {{ recipientInfo.account_number }}
            </p>
            <v-btn
                class="warning copy-button"
                absolute
                x-small
                @click="copyToClipboard(recipientInfo.account_number)"
            >
                Copy
            </v-btn>
        </div>
    </v-col>
</template>

<script>
    export default {
        props: {
            recipientInfo: {
                type: Object,
                default: () => ({}),
            },
            label: {
                type: String,
                default: 'Account Number',
            },
        },
    };
</script>
